import React from 'react';
import { Alert, Typography } from '@mui/material';
import {
  ErrorOutlineRounded as ErrorIcon,
  CheckCircleOutlineOutlined as SuccessIcon,
  WarningAmber as WarningIcon,
} from '@mui/icons-material';
import { AssetronBannerTypes } from '@assetron/common/constants/constant';
import useAssetronAlertStyles from './styles/useAssetronAlertStyles';

export interface AssetronAlertProps {
  message: string;
  type: AssetronBannerTypes;
}

function AssetronAlert({ message, type }: Readonly<AssetronAlertProps>) {
  const { alert, alertIcon, alertText } = useAssetronAlertStyles(type);
  let Icon = ErrorIcon;
  if (type === AssetronBannerTypes.SUCCESS) {
    Icon = SuccessIcon;
  } else if (type === AssetronBannerTypes.WARNING) {
    Icon = WarningIcon;
  } else if (type === AssetronBannerTypes.INFO) {
    Icon = ErrorIcon;
  }

  // Handle newline characters in the message for proper display
  const lines = message?.split('\n');
  const formattedMessage = lines?.map((line, i) => (
    <React.Fragment key={`line-${line.substring(0, 8)}`}>
      {line}
      {i < lines.length - 1 && <br />}
    </React.Fragment>
  ));

  return (
    <Alert variant="outlined" sx={alert} icon={<Icon sx={alertIcon} />}>
      <Typography variant="body_14_medium" sx={alertText}>
        {formattedMessage}
      </Typography>
    </Alert>
  );
}

export default AssetronAlert;
